// extracted by mini-css-extract-plugin
module.exports = {"active":"styles_active__3DNiM","table":"styles_table__2P6AG","header":"styles_header__3ofiR","row":"styles_row__2Gf9g"};